import React from 'react';

import ChangePasswordForm from '../../../components/organism/ChangePasswordForm/ChangePasswordForm';

function ChangePassword() {
  return (
    <div>
      <ChangePasswordForm />
    </div>
  );
}

export default ChangePassword;
